import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Paper,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

interface DeeplinkCreatedModalProps {
  open: boolean;
  deeplink: string;
  onClose: () => void;
}

export function DeeplinkCreatedModal({ open, deeplink, onClose }: DeeplinkCreatedModalProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Djuplänk skapad</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Din djuplänk har skapats:
        </Typography>
        <Paper
          variant="outlined"
          sx={{
            p: 2,
            bgcolor: 'grey.50',
            wordBreak: 'break-all',
            fontFamily: 'monospace',
            fontSize: 13,
          }}
        >
          {deeplink}
        </Paper>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button
          variant="outlined"
          startIcon={<ContentCopyIcon />}
          onClick={() => {
            navigator.clipboard.writeText(deeplink);
          }}
        >
          Kopiera till urklipp
        </Button>
        <Button variant="contained" onClick={onClose}>
          Stäng
        </Button>
      </DialogActions>
    </Dialog>
  );
}
